import React from 'react';
import { DAY_NAMES_PL } from '../utils/constants';

const CalendarDay = ({
  day,
  children,
  className = '',
}) => {
  const dayNameIndex = day.isoWeekday - 1;
  const dayName = DAY_NAMES_PL[dayNameIndex];

  return (
    <div
      className={`calendar-day ${day.isToday ? 'calendar-day--today' : ''} ${className}`}
    >
      <div className="calendar-day__header">
        <span className="calendar-day__name">{dayName}</span>
        <span className="calendar-day__date">{day.dayNumber}</span>
      </div>

      <div className="calendar-day__content">
        {children}
      </div>
    </div>
  );
};

export default CalendarDay;
